import { PopupDropdownMenu } from '@calendly/ui/components/menu';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { useViewportFit } from 'hooks/useViewportFit';
const containerPullRightCss = "cq9kqik";
const containerPullTopCss = "cez0xpo";
const containerWidthAutoCss = "cwk913j";
const containerRemoveTopOffsetCss = "c1y9owb4";
const containerCss = "cm0sapg";
const Container = forwardRef((props, ref) => {
  const {
    conflict,
    fullWidth,
    pullRight,
    pullTop,
    removeTopOffset,
    ...restProps
  } = props;
  return <PopupDropdownMenu ref={ref} {...restProps} className={classNames(containerCss, {
    [containerPullRightCss]: pullRight && !conflict.right || conflict.left && !conflict.right,
    [containerPullTopCss]: pullTop && !conflict.top || conflict.bottom && !conflict.top,
    [containerWidthAutoCss]: !fullWidth,
    [containerRemoveTopOffsetCss]: removeTopOffset
  }, props.className)} />;
});
export const ViewportDropdownMenu = ({
  children,
  viewportOffset = {},
  ...props
}) => {
  const {
    ref,
    topConflict,
    rightConflict,
    bottomConflict,
    leftConflict
  } = useViewportFit(viewportOffset);
  return <Container ref={ref} conflict={{
    top: topConflict,
    right: rightConflict,
    bottom: bottomConflict,
    left: leftConflict
  }} {...props}>
      {children}
    </Container>;
};

require("./viewport_dropdown_menu.wyw-in-js.css!=!../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./viewport_dropdown_menu.js");